module.exports = __webpack_public_path__ + "static/media/figure-5a.8e3cb9b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/faq/change-batteries/figure-5a.jpg
// module id = 1211
// module chunks = 0